<template>
    <component :is="tag" :class="computedClasses">
        <slot></slot>
    </component>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

const props = defineProps({
    tag: {
        type: String as PropType<"p" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6">,
        default: "p",
        validator: (value: string) => ["p", "span", "h1", "h2", "h3", "h4", "h5", "h6"].includes(value),
    },
    variant: {
        type: String as PropType<
            "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body" | "body2" | "caption" | "subtitle" | "subtitle2"
        >,
        validator: (value: string) =>
            ["h1", "h2", "h3", "h4", "h5", "h6", "body", "body2", "caption", "subtitle", "subtitle2"].includes(value),
    },
    className: {
        type: String,
        default: "",
    },
});

const classList: Record<string, string> = {
    h1: "text-3xl font-bold text-gray-700",
    h2: "text-2xl font-bold text-gray-700",
    h3: "text-2xl font-bold text-gray-700",
    h4: "text-xl font-bold text-gray-700",
    h5: "text-lg font-bold text-gray-700",
    h6: "font-bold text-gray-700",
    body: "text-gray-600",
    body2: "text-sm text-gray-600",
    caption: "text-xs font-bold text-gray-400",
    subtitle: "text-sm text-gray-500",
    subtitle2: "text-xs text-gray-500",
};

const computedClasses = computed(() => {
    const baseClass = classList[props.variant ?? props.tag];
    return twMerge(baseClass, props.className);
});
</script>
